export const DEFAULT_DRAGGABLE_LABEL = 'Перенести ячейку';
